module.exports = __webpack_public_path__ + "static/media/MWDOC.1b35776d.png";